/* eslint-disable no-console */
import { AxiosError } from "axios";
import * as rax from "retry-axios";
import { IApiTestParams } from "../shared/types/testing.types";
import {
  PROJECTS_ENDPOINT,
  VERSION_ENDPOINT,
} from "./constants/urls.constants";

export enum EApiTypes {
  PROJECTS = "projects",
  VERSION = "version",
}

export enum EEnvironments {
  DEV = "dev",
  QA = "qa",
  PROD = "prod",
}

const getEndpoint = (apiName: string, params?: IApiTestParams): string => {
  let endpoint;
  switch (apiName) {
    case EApiTypes.PROJECTS:
      endpoint = PROJECTS_ENDPOINT;
      break;
    case EApiTypes.VERSION:
      endpoint = VERSION_ENDPOINT;
      break;
    default:
      endpoint = "/";
      break;
  }

  if (params) {
    if (params.testHttpError) {
      return `${endpoint}?testHttpError=${params.testHttpError}`;
    } else if (params.id) {
      return `${endpoint}/${params.id}`;
    } else {
      return endpoint;
    }
  } else {
    return endpoint;
  }
};

const handleShouldRetry = (
  err: AxiosError<any>,
  raxInstace: typeof rax
): boolean => {
  const { response } = err;
  const cfg: rax.RetryConfig | undefined = raxInstace.getConfig(err);

  if (cfg && cfg.currentRetryAttempt && cfg.retry) {
    if (cfg.currentRetryAttempt >= cfg?.retry) return false;
  }

  if (response && response?.statusText.includes("Network Error")) {
    return true;
  }

  if (typeof err === "string" || err instanceof String) {
    if (err.includes("Network Error")) {
      return true;
    }
  }

  return rax.shouldRetryRequest(err);
};

const handleRetryAttempt = (
  err: AxiosError<any>,
  raxInstace: typeof rax
): void => {
  const cfg = raxInstace.getConfig(err);

  console.warn("------------------------------------------");
  console.warn("- API ERROR ------------------------------");
  console.warn(
    `- Retry attempt #${cfg?.currentRetryAttempt} -----------------------`
  );
  console.warn("------------------------------------------");
  console.log({ err });
};

export default { getEndpoint, handleShouldRetry, handleRetryAttempt };
